// All fetchData/postData endpoints are WP REST routes, so JSON_URL must end
// with /wp-json regardless of whether the env var includes it (Netlify's doesn't)
const wordpressUrl = (process.env.GATSBY_WORDPRESS_URL || '').replace(/\/+$/, '');
export const JSON_URL = wordpressUrl.endsWith('/wp-json') ? wordpressUrl : `${wordpressUrl}/wp-json`;
export const MAPS_API_KEY = process.env.GATSBY_MAPS_API_KEY
export const WP_MEDIA_BASE_URL = 'https://neilhughoffice.wpenginepowered.com/wp-content/uploads'
export const CLOUDINARY_URL = 'https://res.cloudinary.com/dqrekuuax/image/upload'
// Must stay /subscribe/post — /subscribe/post-json 404s on this Mailchimp account
export const MAILCHIMP_ENDPOINT = 'https://neilhugh.us9.list-manage.com/subscribe/post?u=cf160de49aecc078ad6196a36&id=39c2ffcf50'